import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const QuickReplyTemplateListV2 = Loadable(
  lazy(() =>
    import("./QuickReplyTemplateListV2").then(
      ({ QuickReplyTemplateListV2 }) => ({
        default: QuickReplyTemplateListV2,
      })
    )
  )
);

const ManageQuickReplyTemplate = Loadable(
  lazy(() =>
    import("./ManageQuickReplyTemplate").then(
      ({ ManageQuickReplyTemplate }) => ({
        default: ManageQuickReplyTemplate,
      })
    )
  )
);

export const quickReplyTemplateRoutes = [
  {
    path: "/quick-reply-templates",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.META_TEMPLATE]}>
        <QuickReplyTemplateListV2 />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/quick-reply-templates/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.META_TEMPLATE]}>
        <ManageQuickReplyTemplate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/quick-reply-templates/manage/:quickReplyTemplateName",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.META_TEMPLATE]}>
        <ManageQuickReplyTemplate />
      </AuthorizedRoute>
    ),
  },
];
